'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable camelcase */
function OnboardingInfo() {
  this.extends = [_AccountController];

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.dataSanitization = new DataSanitization();

  this._onFormSubmitCallback = null;
  this.formAction = 'account.edit_member';

  this._viewMaps = {};

  this.init = function () {
    this._super();
    var _window = window,
        analytics = _window.analytics;

    // failed min reqs or completed steps in this set

    if (!this.hasVerifiedEmail() || this.hasAllBasicInfo()) {
      // cant share this file and do things this way...
      // TODO: check prereq values for the curent page.
      this.routeToNextStep();
      return;
    }

    this.analytics.pushEvent('virtual-page-view');

    analytics.track('Flow Started', {
      flow_id: 'onboarding',
      product_id: 'mogo',
      screen_name: 'onboarding profile info'
    });

    this._$node = $(this.node);
    this._$form = this._$node.find('.js--onboarding-form')[0];
    this._bindEvents();

    // Form inputs
    this._$formInputs = {
      // Address
      address: this._$node.find('.js--form-address'),
      suite: this._$node.find('.js--form-suite'),
      city: this._$node.find('.js--form-city'),
      province: this._$node.find('.js--form-province'),
      postalCode: this._$node.find('.js--form-postal-code'),
      // Dob
      birthDate: this._$node.find('.js--form-birth-date'),
      // Product of Interest
      productInterests: this._$node.find('.js--products-of-interest'),
      // Credit check consent
      creditCheckOptIn: this._$node.find('.js--credit-check-group'),
      // ToolTip
      creditCheckConsentTooltip: this._$node.find('.js--score-info'),

      loanInterest: this._$node.find('.js--form-loan'),

      // Submit
      submit: this._$node.find('.js--form-submit')
    };

    this.presenter.extendCustomValidations(this.formAction, {
      _hooks: { prehook: this._prehook.bind(this) }
    });

    // Field specific setup:
    this._$formInputs.postalCode.on('change', this.formatPostalCode.bind(this));
    this._setupBirthDate();
    this._setupProductsOfInterest();
    this._setupConsent();

    // global setup:
    this._onFormSubmitCallback = this.presenter.addCallbackToAction(this.formAction, this.onFormSubmittedCallback.bind(this));

    this._prePopulateGatheredDetails();

    this._$portal = $('#Portal');
    this._$portal.mogo().setupTargetAudience();

    // Form field data transformers
    // Get values to be displayed
    // Set values to be sent to BE
    this.presenter.extendViewMap(this._viewMaps);
  };

  this.initAllReady = function () {};

  // ################# Global #################

  this.destroy = function () {
    if (this._$form) {
      // cleanup required object so its ready for the next screen
      delete this._$form.mogo().schema.required;
      if (this._onFormSubmitCallback) {
        this.presenter.removeCallbackFromAction(this.formAction, this._onFormSubmitCallback);
      }
    }
  };

  this._prePopulateGatheredDetails = function () {
    // Get cookie data
    this._cookieData = Cookies.getJSON();

    // cookieName must match 'formdata_profileinfo_' + _$form[elementName]
    for (var input in this._$formInputs) {
      if (this._cookieData.hasOwnProperty('formdata_profileinfo_' + input)) {
        this._$formInputs[input].mogo().val(this._cookieData['formdata_profileinfo_' + input]);
      }
    }
  };

  this._prehook = function () {
    this._setRequiredFields();
  };

  this._setRequiredFields = function () {
    // Choose required fields based on HTML:
    var requiredFieldNames = [];
    var requiredElements = Array.from(this._$form.elements).filter(function (r) {
      return r.getAttribute('data-mogo-ui-required') === 'true';
    });
    for (var i = 0; i < requiredElements.length; i++) {
      requiredFieldNames.push(requiredElements[i].name);
    }
    if (requiredFieldNames.length > 0) {
      // console.log('OnboardingInfo _prehook: required fields:', requiredFieldNames);
      this._$form.mogo().schema.required = requiredFieldNames;
    }
    // TODO: replace with looping through field vars instead
    if ($('.js--products-of-interest').length) {
      if (!this._$form.mogo().schema.required) this._$form.mogo().schema.required = [];
      if (this._$form.mogo().schema.required.indexOf('products_of_interest') === -1) {
        this._$form.mogo().schema.required.push('products_of_interest');
      }
    }
  };

  this.onFormSubmittedCallback = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage(this._$form, {
        productLabel: 'MogoMember'
      });
    } else if (response === 200) {
      var formAnalyticsID = $('.js--onboarding-form').data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
      this.presenter.models.account.updateModel(data, this.onCompletedStep.bind(this, data));
    } else {
      if (data.errors) {
        console.log('Error validating data on BE', data.errors);
        this.analytics.forcePushEvent('generic-push-event', {
          event: ['SetProfileErrors']
        });
        // this._$form.form.mogo().parseErrorObject(data.errors);
      }
      $('#Notification').mogo().get();
    }
  };

  this.onCompletedStep = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
      var _window2, analytics, uuid, first_name, last_name, birthday, _data$products_of_int, products_of_interest, product_interest_trade, product_interest_loan, analyticsData, analyticsRequest, _interestsArr;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Segment Analytics
              _window2 = window, analytics = _window2.analytics;
              uuid = data.uuid, first_name = data.first_name, last_name = data.last_name, birthday = data.birth_date, _data$products_of_int = data.products_of_interest, products_of_interest = _data$products_of_int === undefined ? [] : _data$products_of_int;
              product_interest_trade = products_of_interest.includes('trade') ? '1' : '0';
              product_interest_loan = products_of_interest.includes('loan') ? '1' : '0';
              _context.prev = 4;
              _context.next = 7;
              return analytics.identify(uuid, {
                userId: uuid,
                firstName: first_name,
                lastName: last_name,
                birthday: birthday
              });

            case 7:
              _context.next = 9;
              return analytics.track('Flow Updated', {
                flow_id: 'onboarding',
                product_id: 'mogo',
                screen_name: 'onboarding profile info',
                first_name: first_name,
                last_name: last_name,
                birthday: birthday,
                product_interest_loan: product_interest_loan,
                product_interest_trade: product_interest_trade
              });

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](4);

              console.warn('>>> Error: ' + _context.t0);

            case 14:

              // send analytics to SOA on final step only
              if (this.hasCompletedOrCanSkipAdditionalInfo()) {
                analyticsData = this.analytics.constructData('Complete Profile');
                analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);

                analyticsRequest.send();
              }

              _interestsArr = this.presenter.getModelProperty('account.products_of_interest');

              if (!!_interestsArr && !_interestsArr.includes('loan')) {
                // Remove theme for layout class
                $('#Portal').mogo().removeTargetAudience();
              }

              this.routeToNextStep(); // _OnboardingCoordinator

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[4, 11]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  // ################# Field specific setup #################

  this.formatPostalCode = function (e) {
    var str = $(e.target).val();
    var formattedStr = str.trim().toUpperCase();
    return $(e.target).val(formattedStr);
  };

  this._setupBirthDate = function () {
    if (this._$formInputs.birthDate.length) {
      this._$formInputs.birthDate.on('blur', this.pushBirthdayAnalytics.bind(this));
      this._$formInputs.birthDate.on('change blur', this.setBirthDateValue.bind(this));
    }
  };

  this.setBirthDateValue = function (e) {
    var dob = this.dataSanitization.sanitizeDates(this._$formInputs.birthDate.mogo().val());
    this._$formInputs.birthDate.mogo().val(dob);
  };

  this._setupProductsOfInterest = function () {
    if (this._$formInputs.productInterests.length) {
      // Set product interest model values if user comes back after save
      if (this.presenter.getModelProperty('account.products_of_interest') != null) {
        var product = void 0;
        for (var i = 0; i < this.presenter.getModelProperty('account.products_of_interest').length; i++) {
          product = this.presenter.getModelProperty('account.products_of_interest')[i];
          if (product === 'loan') this.presenter.setModelProperty('account.loan', true);
          if (product === 'trade') this.presenter.setModelProperty('account.trade', true);
        }
      }
    }
  };

  this._setupConsent = function () {
    if (this._$formInputs.creditCheckConsentTooltip.length) {
      // Set consent to checked if user comes back after save
      if (this.presenter.getModelProperty('account.credit_check_opt_in') != null) {
        this.presenter.setModelProperty('account.credit_check_opt_in_preselect', true);
      }

      this._$formInputs.creditCheckConsentTooltip.on('mouseover', this.pushTooltipAnalytics.bind(this));
    }
  };

  // ################# Analytics #################

  this.pushBirthdayAnalytics = function (e) {
    var birthday = this.dataSanitization.sanitizeDates(e.currentTarget.value);
    this.analytics.pushEvent('customer-birthday', { Birthday: [birthday] });
  };

  this.pushTooltipAnalytics = function () {
    this.analytics.pushEvent('tooltip', {
      tooltipContent: ['Credit Check Consent']
    });
  };
  this._bindEvents = function (e) {
    // Trim whitespace from first and last name
    var firstName = document.querySelector('.js--form-first-name');
    var lastName = document.querySelector('.js--form-last-name');

    firstName.addEventListener('input', function () {
      firstName.value = firstName.value ? firstName.value.trimStart() : '';
    });
    lastName.addEventListener('input', function () {
      lastName.value = lastName.value ? lastName.value.trimStart() : '';
    });
  };
}